import { Icon } from '@buggy/shared'
import { isNil } from 'lodash-es'
import type { FunctionComponent } from 'react'
import styled from 'styled-components'
import { useIntl } from '@/i18n/hooks/use-intl'
import type { Nullable } from '@/types/nullable'
import { PlatformShortcode } from '@/utils/convert-platform'

export interface PostCardStatisticProps {
  className?: string
  platformShortCode?: PlatformShortcode
  isDisableLike?: boolean
  likeCount?: Nullable<number>
  commentCount?: Nullable<number>
  viewCount?: Nullable<number>
  playCount?: Nullable<number>
  repostAndQuoteCount?: Nullable<number>
  shareCount?: Nullable<number>
}

const Statistic: FunctionComponent<PostCardStatisticProps> = ({
  className,
  platformShortCode,
  likeCount,
  isDisableLike = false,
  commentCount,
  viewCount,
  playCount,
  repostAndQuoteCount,
  shareCount,
}) => {
  const { formatMessage, formatNumber } = useIntl()

  return (
    <Wrapper className={className}>
      {!isNil(likeCount) && (
        <Data>
          <Icon name='thumbs-up' />
          {isDisableLike
            ? formatMessage({ id: 'general:hidden' })
            : formatNumber(likeCount, { isCompactDisplay: true })}
        </Data>
      )}
      {!!commentCount && (
        <Data>
          <Icon name='message-circle' />
          {formatNumber(commentCount, { isCompactDisplay: true })}
        </Data>
      )}
      {/** IG 不顯示觀看數，是歷史包袱，資料庫欄位太古老所以不能動 https://www.notion.so/ikala/Staging-Search-IG-5e3d1f568609498ea318a45ef9658244?pvs=4 */}
      {!!viewCount && platformShortCode !== PlatformShortcode.Instagram && (
        <Data>
          <Icon name='eye' />
          {formatNumber(viewCount, { isCompactDisplay: true })}
        </Data>
      )}
      {!!playCount && (
        <Data>
          <Icon name='play' />
          {formatNumber(playCount, { isCompactDisplay: true })}
        </Data>
      )}
      {!!repostAndQuoteCount && (
        <Data>
          <Icon name='retweet-outlined' />
          {formatNumber(repostAndQuoteCount, { isCompactDisplay: true })}
        </Data>
      )}
      {!!shareCount && (
        <Data>
          <Icon name='arrow-forward-outlined' />
          {formatNumber(shareCount, { isCompactDisplay: true })}
        </Data>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`

const Data = styled.div`
  font-size: 14px;
  color: ${({ theme }): string => theme.colors.text.secondary};
  display: flex;
  align-items: center;
  gap: 3px;
`

const PostCardStatistic = styled(Statistic)``

export default PostCardStatistic
